import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import getShippingContext from "@faire/web-api/api/help-center/contexts/brand-orders/brandOrderToken/get";
var NO_SHIPPING_CONTEXT = {
  field: "shippingContext",
  data: undefined
};
export var ShippingContextDataFn = function ShippingContextDataFn(context) {
  var _context$selectedBran, _context$selectedBran2;
  var brandOrderToken = (_context$selectedBran = context.selectedBrandOrder) === null || _context$selectedBran === void 0 ? void 0 : (_context$selectedBran2 = _context$selectedBran.brand_order) === null || _context$selectedBran2 === void 0 ? void 0 : _context$selectedBran2.token;
  if (!brandOrderToken) {
    return Promise.resolve(NO_SHIPPING_CONTEXT);
  }
  return getShippingContext(brandOrderToken).then(function (response) {
    return {
      field: "shippingContext",
      data: response
    };
  })["catch"](function () {
    return NO_SHIPPING_CONTEXT;
  });
};